import React from 'react';
import { Card, CardContent, Typography } from '@mui/material';
import Comment from './Comment';

export default function CommentList({ comments = [], onReply }) {
  return (
    <Card>
      <CardContent>
        <Typography variant="h6" component="h2" gutterBottom>
          Comments
        </Typography>
        <section aria-label="Comments">
          {comments.length === 0 ? (
            <Typography color="text.secondary">No comments yet.</Typography>
          ) : (
            comments.map((c) => (
              <Comment key={c.commentId || c.createdAt} comment={c} onReply={onReply} />
            ))
            )}
        </section>
      </CardContent>
    </Card>
  );
}
